'use strict';

let ProductServiceModule = require('./ProductService');

module.exports = function(param){
    // Adding support to use individual module standalone
    if(typeof param !== "object"){
        param = {};
    }
    // providing option to inject Custom EventBus
    if(param && typeof param._EventBus !== "object"){
        param._EventBus = require('../core/EventBus');
    }
    return new ProductServiceModule(param);
};


// WEBPACK FOOTER //
// ./src/product/index.js